import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.snapchatApiUrl);

export async function getSnapchatProfile({ brandId }, config = {}) {
  return http.get(`/brands/${brandId}/profile`, config);
}

export async function getSnapchatProfileAllBrands({ brandIds }, config = {}) {
  return http.put(`/brand_profiles`, { brand_ids: brandIds }, config);
}
